import React, { useEffect, useState } from 'react';
import { FaChevronDown } from 'react-icons/fa';
import { ImageWithFallback } from './ImageWithFallback';
import monisePhoto from '../assets/monise.png';

const valores = [
  'Compromisso com a qualidade em cada projeto.',
  'Transparência e honestidade em todos os processos.',
  'Atendimento humanizado e próximo ao cliente.',
  'Inovação e aprendizado contínuo.',
  'Responsabilidade com prazos e resultados.',
  'Desenvolvimento de soluções personalizadas.',
  'Paixão por tecnologia e transformação digital.',
];

const cards = [
  {
    id: 'missao',
    titulo: 'Missão',
    content: (
      <p className="text-dark/80 dark:text-cream/80 leading-relaxed font-body">
        Ajudar empresas e empreendedores a fortalecerem sua presença digital por meio de sites modernos,
        profissionais e personalizados, transformando ideias em soluções que geram credibilidade,
        visibilidade e oportunidades de negócio.
      </p>
    ),
  },
  {
    id: 'visao',
    titulo: 'Visão',
    content: (
      <p className="text-dark/80 dark:text-cream/80 leading-relaxed font-body">
        Ser reconhecida como referência no desenvolvimento de sites e soluções digitais,
        contribuindo para o crescimento de empresas através da tecnologia, inovação
        e atendimento próximo aos clientes.
      </p>
    ),
  },
  {
    id: 'valores',
    titulo: 'Valores',
    content: (
      <ul className="space-y-2">
        {valores.map((valor) => (
          <li key={valor} className="flex items-start gap-2 text-dark/80 dark:text-cream/80 text-sm font-body">
            <span className="flex-shrink-0 w-1.5 h-1.5 rounded-full bg-burnt mt-2" />
            {valor}
          </li>
        ))}
      </ul>
    ),
  },
];

const Sobre = () => {
  const [isMobile, setIsMobile] = useState(() =>
    typeof window !== 'undefined' ? window.matchMedia('(max-width: 767px)').matches : false
  );
  const [openId, setOpenId] = useState(null);

  useEffect(() => {
    const mq = window.matchMedia('(max-width: 767px)');
    const update = () => {
      setIsMobile(mq.matches);
      if (!mq.matches) setOpenId(null);
    };
    update();
    mq.addEventListener('change', update);
    return () => mq.removeEventListener('change', update);
  }, []);

  const toggle = (id) => {
    if (!isMobile) return;
    setOpenId((prev) => (prev === id ? null : id));
  };

  const isOpen = (id) => !isMobile || openId === id;

  return (
    <section id="sobre" className="py-32 bg-white dark:bg-dark-surface transition-colors duration-500">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center mb-24">
          <div className="gsap-reveal-left order-2 lg:order-1">
            <div className="relative">
              <div className="absolute -inset-4 bg-burnt/10 rounded-2xl blur-2xl" />
              <ImageWithFallback
                src={monisePhoto}
                alt="Monise Silva - Desenvolvedora MS Digitais"
                className="relative rounded-2xl shadow-premium dark:shadow-premium-dark w-full h-auto min-h-[400px] object-cover border border-brown/10 dark:border-burnt/20"
                placeholderLabel="Monise Silva"
              />
            </div>
          </div>

          <div className="gsap-reveal-right order-1 lg:order-2">
            <p className="text-burnt font-heading font-semibold uppercase tracking-wider text-sm mb-4">
              Sobre mim
            </p>
            <h2 className="text-4xl md:text-5xl font-heading font-bold text-dark dark:text-cream mb-6">
              Monise Silva
            </h2>
            <p className="text-lg text-dark/80 dark:text-cream/80 mb-4 leading-relaxed font-body">
              Sou desenvolvedora e estrategista digital na <strong className="text-dark dark:text-cream">MS Digitais</strong>.
              Atuo como parceira direta de empreendedores e empresas — sem intermediários, sem agências impessoais.
              Você trata com quem executa.
            </p>
            <p className="text-lg text-dark/80 dark:text-cream/80 mb-4 leading-relaxed font-body">
              Meu foco principal é a criação de <strong className="text-burnt">sites institucionais</strong> modernos,
              profissionais e personalizados. Também desenvolvo sistemas quando o negócio precisa de soluções mais completas.
            </p>
            <p className="text-lg text-dark/80 dark:text-cream/80 leading-relaxed font-body">
              Descomplico o digital para o dono de negócio: foco no que traz resultado, não apenas em estética.
              Cada projeto é tratado como patrimônio digital real.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-8 mb-16">
          {cards.map((card) => {
            const open = isOpen(card.id);
            return (
              <div
                key={card.id}
                className="gsap-reveal rounded-2xl bg-cream dark:bg-dark-bg border border-brown/10 dark:border-burnt/10 overflow-hidden"
              >
                <button
                  type="button"
                  onClick={() => toggle(card.id)}
                  className={`w-full flex items-center justify-between gap-3 text-left min-h-[48px] px-6 py-4 md:px-8 md:pt-8 md:pb-4 md:cursor-default ${
                    isMobile ? 'cursor-pointer' : 'pointer-events-none'
                  }`}
                  aria-expanded={open}
                  aria-controls={`sobre-${card.id}`}
                  data-cursor={isMobile ? 'pointer' : undefined}
                >
                  <h3 className="text-burnt font-heading font-bold text-lg uppercase tracking-wider">
                    {card.titulo}
                  </h3>
                  <FaChevronDown
                    className={`text-burnt text-sm shrink-0 transition-transform duration-300 md:hidden ${
                      open ? 'rotate-180' : ''
                    }`}
                    aria-hidden="true"
                  />
                </button>

                <div
                  id={`sobre-${card.id}`}
                  className={`px-6 md:px-8 pb-6 md:pb-8 transition-all duration-300 ${
                    open ? 'block' : 'hidden md:block'
                  }`}
                >
                  {card.content}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Sobre;
